import React, { useMemo } from 'react';
import { useParams, useLocation, Navigate } from 'react-router-dom';
import YearTag from './YearTag';
import { YEAR_TO_TAG_ID } from './yearConfig';

export default function YearTagRoute({ forcedYear, yearsIsVisible, monthsIsVisible, keywordsIsVisible }) {
    const { year } = useParams();
    const location = useLocation();

    const parsedYear = useMemo(() => {
        const searchParams = new URLSearchParams(location.search);
        const yearFromQuery = searchParams.get('y');
        const yearString =
            forcedYear != null ? String(forcedYear) : (year ?? yearFromQuery);
        const n = Number(yearString);
        return Number.isInteger(n) ? n : null;
    }, [forcedYear, year, location.search]);

    if (!parsedYear) {
        return <Navigate to="/" replace />;
    }

    const tagId = YEAR_TO_TAG_ID[parsedYear] || `${parsedYear}public`;

    return <YearTag tagId={tagId} handwritingYear={parsedYear} yearsIsVisible={yearsIsVisible} monthsIsVisible={monthsIsVisible} keywordsIsVisible={keywordsIsVisible} />;
}

